import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import TrackingPublico from './pages/TrackingPublico';
import AdminPanel from './pages/AdminPanel';

function Navbar() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  return (
    <header style={{
      background: 'var(--navy)',
      height: 60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 28px',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
    }}>
      {/* Logo */}
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
          <rect width="28" height="28" rx="7" fill="#00b894"/>
          <path d="M5 18 L10 10 L14 15 L18 8 L23 18 Z" fill="none" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
          <rect x="4" y="20" width="20" height="2.5" rx="1.25" fill="white" opacity="0.5"/>
        </svg>
        <span style={{ fontWeight: 800, fontSize: 17, color: '#fff', letterSpacing: '-0.3px' }}>
          Import<span style={{ color: '#00b894' }}>Track</span>
        </span>
      </Link>

      {/* Nav buttons */}
      <nav style={{ display: 'flex', gap: 6 }}>
        <NavLink to="/" active={!isAdmin} label="Tracking" icon="🔍" />
        <NavLink to="/admin" active={isAdmin} label="Admin" icon="⚙️" />
      </nav>
    </header>
  );
}

function NavLink({ to, active, label, icon }) {
  return (
    <Link to={to} style={{
      display: 'flex', alignItems: 'center', gap: 6,
      padding: '6px 14px',
      borderRadius: 8,
      fontSize: 13,
      fontWeight: active ? 600 : 400,
      color: active ? '#00b894' : 'rgba(255,255,255,0.55)',
      background: active ? 'rgba(0,184,148,0.12)' : 'transparent',
      border: active ? '1px solid rgba(0,184,148,0.25)' : '1px solid transparent',
      transition: 'all 0.18s',
    }}>
      <span>{icon}</span> {label}
    </Link>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<TrackingPublico />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}
